module.exports = __webpack_public_path__ + "static/media/Flaticon.711dc749.eot";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flaticons/Flaticon.eot
// module id = 383
// module chunks = 0